/* AddImagesSummaryComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AddImagesSummaryRenderer");

/**
 * AddImagesSummaryComponent
 *
 * Component for displaying the summary of image linking results
 * Shows success/failure counts and detailed error messages
 *
 * @class
 * @extends EventEmitter
 */
class AddImagesSummaryComponent extends EventEmitter {
    /**
     * @param {Object} summaryData - Summary data with success/failure counts and errors
     * @param {number} summaryData.totalImages - Total number of images attempted
     * @param {number} summaryData.successCount - Number of successful links
     * @param {number} summaryData.failureCount - Number of failed links
     * @param {Array<string>} summaryData.errors - Array of error messages
     * @param {Object} logger - Logger instance
     */
    constructor(summaryData, logger) {
        super();
        this._logger = logger;
        this._summaryData = summaryData;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    get summaryData() {
        return this._summaryData;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    /**
     * Register any listeners needed for this component
     */
    _registerListeners() {}

    /**
     * Unregister listeners for this component
     */
    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    /**
     * Get the renderer instance for this component
     * @returns {AddImagesSummaryRenderer}
     */
    getRenderer() {
        return this._renderer;
    }

    /**
     * Clean up and shutdown the component
     * @returns {Promise}
     */
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._summaryData = undefined;
            },
            (err) => {
                this._logger &&
                    this._logger.warn({error: err}, "AddImagesSummaryComponent.shutdown() error");
            }
        );
    }

    /**
     * Handler for the OK button: resolves the UI context
     */
    sendOk() {
        this._context.resolve({});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
}

module.exports = AddImagesSummaryComponent;
